import { render, staticRenderFns } from "./lawsuitPaymentForm.vue?vue&type=template&id=775aef8c&scoped=true"
import script from "./lawsuitPaymentForm.vue?vue&type=script&lang=js"
export * from "./lawsuitPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775aef8c",
  null
  
)

export default component.exports